export const projects = (state = [], action) => {
  switch (action.type) {
    case 'SET_AVAILABLE_PROJECTS': 
      return action.projects
    default:
      return state
  }
}